module.exports = __webpack_public_path__ + "img/Journal.dedc30d5.png";